import React, { useContext, useEffect, useState } from "react";
import SikkaCardHeader from "../../../common/SikkaCardHeader";
import { Button, Card, CardBody, Col, Label, Row } from "reactstrap";
import APICall from "../../../../services/apiCall";
import { toast } from "react-toastify";
import Scrollbars from "react-custom-scrollbars-2";
import Select from "react-select";
import classNames from "classnames";
import APIPortalTable from "../../../common/Table/APIPortalTable";
import AppContext from "../../../../context/Context";
import SikkaSelect from "../../../common/SikkaSelect/SikkaSelect";
import jsPDF from "jspdf";
import "jspdf-autotable";

const styles = {
  control: (base) => ({
    ...base,
    fontSize: "13px",
    minHeight: "35px",
    height: "35px",
    fontWeight: "400",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "13px",
  }),
};

const PMSesSupported = () => {
  const [domainNames, setDomainNames] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState("All");
  const [PMSData, setPMSData] = useState([]);
  const [selectedPMSData, setSelectedPMSData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDataColumns, setSelectedDataColumns] = useState([]);
  const [PMSNameFilterOptions, setPMSNameFilterOptions] = useState([]);
  const [selectedFilterPMSOption, setSelectedFilterPMSOption] = useState({
    value: 0,
    label: "All",
  });
  const [specialityFilterOptions, setSpecialityFilterOptions] = useState([]);
  const [selectedFilterSpeciality, setSelectedFilterSpeciality] = useState({
    value: 0,
    label: "All",
  });
  const { isDark } = useContext(AppContext);

  const { loginUserDetails } = useContext(AppContext);

  useEffect(() => {
    setLoading(true);
    let params={
      devid:loginUserDetails.dev_id
    }
    APICall.servertrip("GET", "domain_for_pms_list", loginUserDetails,params).then(
      (res) => {
        const items = res?.data?.items ? res?.data?.items : [];
        items.unshift({ domain: "All" });
        setDomainNames(items);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        setLoading(false);
        toast.error(resMessage);
      }
    );

    
    APICall.servertrip("GET", "pms_compatible_list", loginUserDetails,params).then(
      (res) => {
        const items = res?.data?.items;
        items.map((data, index) => {
          data["id"] = index;
          return data;
        });
        setPMSData(items);

        let pmsNamesArray = res?.data?.items.map((data) => {
          return data.pms_name;
        });
        pmsNamesArray.sort().unshift("All");

        setPMSNameFilterOptions(new Set(pmsNamesArray));

        let specialityArray = res?.data?.items.map((data) => {
          return data.specialty;
        });
        specialityArray.sort().unshift("All");

        setSpecialityFilterOptions(
          new Set(specialityArray).filter((d) => d !== "")
        );

        // setSelectedFilterPMSOption({
        //   index: 0,
        //   value: PMSNamesArray[0],
        // });
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
      }
    );
  }, []);

  useEffect(() => {
    if (PMSData.length > 0) {
      let selected = [];
      if (selectedDomain !== "All") {
        selected = PMSData.filter((val) => val.domain === selectedDomain);
      } else {
        selected = PMSData;
      }

      setSelectedPMSData(selected);
      if (selected.length > 0) {
        let columns = [];
        Object.keys(selected?.[0]).forEach((val) => {
          if (val !== "display_pms_name") {
            let upper = val
              .charAt(0)
              .toUpperCase()
              .concat(val.slice(1));
            let removeUnderscore = upper.split("_").map((str) => {
              return str
                .charAt(0)
                .toUpperCase()
                .concat(str.slice(1));
            });
            columns.push(removeUnderscore.join(" "));
          }
        });
        setSelectedDataColumns(columns);
      }
    }
  }, [PMSData, selectedDomain]);

  // useEffect(() => {
  //   if (selectedFilterSpeciality.label === "All" && selectedFilterPMSOption.label === "All") {
  //     if (selectedDomain === "All") {
  //       setSelectedPMSData(PMSData);
  //     } else {
  //       setSelectedPMSData(PMSData.filter((val) => val.domain === selectedDomain));
  //     }
  //   } else if (selectedFilterSpeciality.label !== "All" && selectedFilterPMSOption.label === "All") {
  //     let filtered1;
  //     if (selectedDomain === "All") {
  //       filtered1 = PMSData;
  //     } else {
  //       filtered1 = PMSData.filter((data) => data.domain === selectedDomain);
  //     }
  //     let filtered2 = filtered1.filter((data) => data.specialty === selectedFilterSpeciality.label);
  //     setSelectedPMSData(filtered2);
  //   } else if (selectedFilterSpeciality.label === "All" && selectedFilterPMSOption.label !== "All") {
  //     let filtered1;
  //     if (selectedDomain === "All") {
  //       filtered1 = PMSData;
  //     } else {
  //       filtered1 = PMSData.filter((data) => data.domain === selectedDomain);
  //     }
  //     let filtered2 = filtered1.filter((data) => data.pms_name === selectedFilterPMSOption.label);
  //     setSelectedPMSData(filtered2);
  //   } else {
  //     let filtered = selectedPMSData.filter((data) => data.specialty === selectedFilterSpeciality.label);
  //     setSelectedPMSData(filtered);
  //   }
  // }, [selectedFilterSpeciality]);

  useEffect(() => {
    if (
      selectedFilterPMSOption.label === "All" &&
      selectedFilterSpeciality.label === "All"
    ) {
      if (selectedDomain === "All") {
        setSelectedPMSData(PMSData);
      } else {
        setSelectedPMSData(
          PMSData.filter((val) => val.domain === selectedDomain)
        );
      }
    } else if (
      selectedFilterPMSOption.label !== "All" &&
      selectedFilterSpeciality.label === "All"
    ) {
      let filtered1;
      if (selectedDomain === "All") {
        filtered1 = PMSData;
      } else {
        filtered1 = PMSData.filter((data) => data.domain === selectedDomain);
      }
      let filtered2 = filtered1.filter(
        (data) => data.pms_name === selectedFilterPMSOption.label
      );
      setSelectedPMSData(filtered2);
    } else if (
      selectedFilterPMSOption.label === "All" &&
      selectedFilterSpeciality.label !== "All"
    ) {
      let filtered1;
      if (selectedDomain === "All") {
        filtered1 = PMSData;
      } else {
        filtered1 = PMSData.filter((data) => data.domain === selectedDomain);
      }
      let filtered2 = filtered1.filter(
        (data) => data.specialty === selectedFilterSpeciality.label
      );
      setSelectedPMSData(filtered2);
    } else {
      let filtered = selectedPMSData.filter(
        (data) => data.pms_name === selectedFilterPMSOption.label
      );
      setSelectedPMSData(filtered);
    }
  }, [selectedFilterPMSOption]);

  const columns = [
    {
      accessorKey: "domain",
      header: "Domain",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "delta_sync",
      header: "Delta Sync",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "specialty",
      header: "Speciality",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "pms_name",
      header: "PMS Name",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "version",
      header: "Version",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    // {
    //   accessorKey: "release_state",
    //   header: "Release State",
    //   enableResizing: false,
    //   csvExport: true,
    //   csvFormatter: (cell, row, rowIndex) => {
    //     if (cell === "") {
    //       return "--";
    //     } else {
    //       return cell;
    //     }
    //   },

    //   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    // },
    {
      accessorKey: "appointment_status_writeback",
      header: "Appointment Status Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "payment_writeback",
      header: "Payment Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "new_appointment_writeback",
      header: "New Appointment Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "new_patient_writeback",
      header: "New Patient Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "note_writeback",
      header: "Notes Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "claim_notes_status_writeback",
      header: "Claim Notes Status Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "insurance_payment_writeback",
      header: "Insurance Payment Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "lab_result_writeback",
      header: "Lab Result Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "document_writeback",
      header: "Document Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "perio_chart_writeback",
      header: "Perio Chart Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "update_patient_writeback",
      header: "Update Patient Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "update_appointment_writeback",
      header: "Update Appointment Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "procedure_writeback",
      header: "Procedure  Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "update_fee_schedule_writeback",
      header: "Update Fee Schedule Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "new_claim_writeback",
      header: "New Claim Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,

    },
    {
      accessorKey: "update_payment_writeback",
      header: "Update Payment Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
    {
      accessorKey: "treatment_plan_writeback",
      header: "Treatment Plan Writeback",
      enableResizing: false,
      csvExport: true,
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },

      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },
  ];

  const handlePMSPdfExport = (exportData) => {
    const doc = new jsPDF("l", "mm", "a4");

    doc.setFontSize(16);
    doc.text("PMS Integration List", 14, 15);

    const sideMargin = 20;

    doc.autoTable({
      head: [exportData.headers],
      body: exportData.data.map((row) =>
        exportData.headers.map((header) => row[header] || "--")
      ),
      startY: 25,
      styles: {
        fontSize: 8,
        cellPadding: 1,
        overflow: "linebreak",
        cellWidth: "wrap",
      },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 20 },
        2: { cellWidth: 20 },
        3: { cellWidth: 25 },
        4: { cellWidth: 22 },
        5: { cellWidth: 20 },
        6: { cellWidth: 20 },
        7: { cellWidth: 20 },
        8: { cellWidth: 20 },
        9: { cellWidth: 20 },
        10: { cellWidth: 20 },
        11: { cellWidth: 20 },
        12: { cellWidth: 20 },
        13: { cellWidth: 20 },
        14: { cellWidth: 20 },
        15: { cellWidth: 20 },
        16: { cellWidth: 20 },
        17: { cellWidth: 20 },
        18: { cellWidth: 20 },
        19: { cellWidth: 20 },
        20: { cellWidth: 20 },
        21: { cellWidth: 20 },
        22: { cellWidth: 20 },
      },
      headStyles: {
        fillColor: [44, 123, 229],
        textColor: 255,
        fontSize: 7,
        fontStyle: "bold",
        cellPadding: 1,
        halign: "center",
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      margin: { top: 25, left: 15, right: 5 },
      theme: "grid",
      tableWidth: "auto",
    });

    doc.save("Pmslist.pdf");
  };
  return (
    <>
      <Card>
        <SikkaCardHeader title={"PMS Integration"} />

        <CardBody className="bg-light p-0 header-wrap-fix th">
          <Row className="mb-2">
            <Col>
              <div className="container-fluid py-2">
                <Scrollbars style={{ height: "80px" }}>
                  <div
                    className="d-flex flex-row flex-nowrap"
                    style={{ width: "100%" }}
                  >
                    {domainNames.map((val, index) => (
                      <button
                        key={index}
                        // className="card mb-2"
                        className={classNames("card mb-2", {
                          "border border-primary":
                            selectedDomain === val.domain,
                          "btn-text-color": true,
                        })}
                        onClick={(e) => {
                          setSelectedDomain(e.target.value);
                          setSelectedFilterSpeciality({
                            value: 0,
                            label: "All",
                          });
                          setSelectedFilterPMSOption({
                            value: 0,
                            label: "All",
                          });
                        }}
                        value={val.domain}
                        style={{
                          minHeight: "60px",
                          minWidth: "150px",
                          marginRight: "5px",
                          justifyContent: "center",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                      >
                        {val.domain === "zAudiology" ? "Audiology" : val.domain}
                      </button>
                    ))}
                  </div>
                </Scrollbars>
              </div>
            </Col>
          </Row>

          <Row className="d-flex p-1 mb-3">
            <Col className="d-flex flex-column align-items-start ml-2">
              <Label className="mr-3 fs--1">Filter By PMS Name</Label>
              <div
                style={{
                  width: "250px",
                  marginRight: "10px",
                }}
              >
                <SikkaSelect
                  // styles={styles}
                  classNamePrefix="react-select"
                  placeholder="Filter By PMS Name"
                  options={PMSNameFilterOptions.map((option, index) => {
                    return {
                      value: index,
                      label: option,
                    };
                  })}
                  defaultValue={selectedFilterPMSOption}
                  onChange={(selectedOption) => {
                    setSelectedFilterPMSOption(selectedOption);
                  }}
                />
              </div>
            </Col>
          </Row>
          <APIPortalTable
            data={selectedPMSData}
            columns={columns}
            loading={loading}
            enablePagination={true}
            CSVFileName={"Pmslist.csv"}
            enableStickyHeader={true}
            onPdfExport={handlePMSPdfExport}
            enablePdfExport={true}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default PMSesSupported;
